import StoreManager from "./manager";

export const Store = StoreManager.getStore();

export const History = StoreManager.getHistory();

/**
 * A brand new store, isolated from the shared one above.
 *
 * The SSR loader calls this once per request: the shared store is a single
 * instance for the whole node process, so dispatching request data into it
 * lets concurrent renders overwrite each other's country and session.
 *
 * It lives here, and not in `../store`, on purpose — importing the factory
 * module directly from the server would make it the entry point of the store
 * module graph (store/index -> actions -> auth -> store/store -> manager ->
 * store/index) and the cycle would resolve to an undefined factory.
 *
 * @returns {*} a redux store nobody else holds a reference to
 */
export const createRequestStore = () => StoreManager.createState().getStore();

export default StoreManager.getStore();
